import React, { Component } from "react";
import {
  alert, toFixed, format_date, GET, PUT, loading, Status,
  DateRangePicker, Navbar, Modal, profile
} from "../../components/CustomComponent.js";

import Swal from "sweetalert2";
import Footer from "../../components/Footer.js";
import { report_preorder, report_tax_invoice } from "../../components/Report.js";
import LOGOLARGE from "../../assets/images/logo512.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { PROCESS_TYPE } from "../../config/process-type.js";

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      modal_detail: false,
      filter_data_search: "",
      filter_start_date: profile?.user_type === "super_user" ? new Date(today.getFullYear(), today.getMonth(), today.getDate() - 3) : "",
      filter_end_date: profile?.user_type === "super_user" ? today : "",
      filter_status: "",
      
      data: [],
      count: Infinity,
      page: 1,
      isLoading: false,
      
      select_tab: -1,
      detail: null,

      count_cancel: 0,
      count_delivering: 0,
      count_pending: 0,
      count_preparing: 0,
      count_returned: 0,
      count_success: 0,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.Get(1);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { isLoading, data, count, page } = this.state;
    // ถ้ากำลังโหลด หรือโหลดมาครบจำนวนทั้งหมดแล้ว ให้หยุด
    if (isLoading || data.length >= count) return;

    if (
      window.innerHeight + document.documentElement.scrollTop + 200 >=
      document.documentElement.scrollHeight
    ) {
      this.Get(page + 1);
    }
  };

  Get = async (targetPage = 1) => {
    const { filter_data_search, filter_start_date, filter_end_date, filter_status, data, isLoading } = this.state;
    
    // ป้องกันการเรียกซ้อนกัน
    if (isLoading) return;
    this.setState({ isLoading: true });

    // ปิด Global loading ถ้าเป็นการเลื่อนหน้า เพื่อไม่ให้รบกวน UX แต่เปิดเฉพาะตอนโหลดหน้าแรก
    if (targetPage === 1) loading(true);

    let [result, result_count] = await Promise.all([ 
      GET("v1/market/orders", {
      page_size: 10,
      page: targetPage,
      data_search: filter_data_search,
      start_date: filter_start_date ? format_date(filter_start_date, "yyyy-mm-dd", "en") : "",
      end_date: filter_end_date ? format_date(filter_end_date, "yyyy-mm-dd", "en") : "",
      order_status: filter_status,
      // แสดงเฉพาะรายการที่สั่งจากเว็บนี้ ไม่ปนกับ LucidTopup
      process_type: PROCESS_TYPE
    }),
    GET("v1/market/orders/counts", { data_search: filter_data_search,
      start_date: filter_start_date ? format_date(filter_start_date, "yyyy-mm-dd", "en") : "",
      end_date: filter_end_date ? format_date(filter_end_date, "yyyy-mm-dd", "en") : "",
      process_type: PROCESS_TYPE
    })
  ])
    ;

    if (result?.status) {
      this.setState({ 
        // ถ้าหน้า 1 ให้ใช้ข้อมูลใหม่เลย ถ้าหน้าอื่นๆ ให้ต่อท้ายข้อมูลเดิม
        data: targetPage === 1 ? result.data : [...data, ...result.data], 
        count: result.pagination?.count,
        page: targetPage,
      });
    } else {
      localStorage.clear();
      alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
    }
    if(result_count?.status){
      this.setState({
        count_cancel: result_count.data?.cancel || 0,
        count_delivering: result_count.data?.delivering || 0,
        count_pending: result_count.data?.pending || 0,
        count_preparing: result_count.data?.preparing || 0,
        count_returned: result_count.data?.returned || 0,
        count_success: result_count.data?.success || 0,
      })
    }
    
    this.setState({ isLoading: false });
    if (targetPage === 1) loading(false);
  };

  CancelTransaction = async (uid) => {
      if (
        await alert(
          "",
          "info",
          "ยืนยัน",
          "คุณยืนยันที่จะยกเลิกรายการสั่งซื้อนี้ใช่ไหม?",
          "ยืนยัน",
          "ยกเลิก",
        )
      ) {
        loading(true);
        let body = {
          order_status: "cancel"
        };
        let result = await PUT(`v1/market/orders/` + uid, body);
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "แจ้งเตือน",
            result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
          );
        }
  }
  }

  GotoProduct = async (product_code) => {
     let [result] = await Promise.all([
      GET("v1/market/products", { product_code }),
    ]);
    if (result?.status) {
      window.open(result.data.remark,"_blank")
    }
  }

  // --- Helper Methods ---

  handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = LOGOLARGE;
  };

  renderOrderItem = (order, index) => (
    <div key={index} className="w-100 d-flex justify-content-between border-bottom pt-3 pb-2">
      <a className="d-flex text-decoration-none" href={`/product-detail?pc=${order.product_code}`}>
        <img
          alt="THUMBNAIL"
          src={order?.product_image || LOGOLARGE}
          className="wpx-100 hpx-100 bg-secondary-light border-secondary border-1"
          style={{ objectFit: "cover" }}
          loading="lazy"
          onError={this.handleImgError}
        />
        <div className="px-3">
          <div className="overflow-hidden text-dark" style={{ lineHeight: 1.2, maxHeight: 36, maxWidth: 700 }}>
            {order.product_name}
          </div>
          <div className="fw-bold text-orange">฿{toFixed(order.price)}</div>
        </div>
      </a>
      <div className="text-end">
        <div>x{order.quantity}</div>
        <div className="fw-bold">฿{toFixed(Number(order.price) * Number(order.quantity))}</div>
        {profile?.user_type === "super_user" && (
          <span className="rounded-circle bg-secondary-light wpx-25 hpx-25 ms-auto mt-4 pointer d-flex align-items-center justify-content-center icon" onClick={() => {
            this.GotoProduct(order.product_code)
          }}>{"\uf0c1"}</span>
        )}
      </div>
    </div>
  );

  renderStatusBadge = (item) => {
    const status = item?.order_status;
    const status_payment = item?.transaction?.status;
    if (status_payment === "cancel") return Status("ยกเลิก", "danger");
    if (status === "pending") return status_payment === "success" ? Status("จัดเตรียมสินค้า", "orange") : Status("รอชำระเงิน", "warning");
    if (status === "preparing") return Status("จัดเตรียมสินค้า", "orange");
    if (status === "delivering") return Status("อยู่ในระหว่างส่งสินค้า", "info");
    if (status === "success") return Status("จัดส่งแล้ว", "success");
    if (status === "returned") return Status("คืนสินค้า", "secondary");
    if (status === "cancel") return Status("ยกเลิก", "danger");
    return null;
  };

 renderModalBanner = (detail) => {
  if (!detail?.transaction) return null;
  const status = detail.order_status;
  const status_payment = detail.transaction.status;

  // 1. กรณีถูกยกเลิก (Cancel) แสดงเป็น Banner แจ้งเตือนสีแดง
  if (status === "cancel" || status_payment === "cancel") {
    return (
      <div className="rounded-4 p-4 bg-danger text-white mb-2" style={{ lineHeight: "1.6" }}>
        <h4 className="mb-2 fw-bold">
          <span className="icon me-2">{"\uf00d"}</span> ยกเลิกรายการ
        </h4>
        <div>คำสั่งซื้อของคุณถูกยกเลิกเรียบร้อยแล้ว</div>
        <small className="opacity-75">หากมีข้อสงสัย กรุณาติดต่อผู้ขายหรือฝ่ายบริการลูกค้า</small>
      </div>
    );
  }

  // 2. กรณีคืนสินค้า (Returned) แสดงเป็น Banner แจ้งเตือนสีส้มอ่อน/เหลืองทอง
  if (status === "returned") {
    return (
      <div className="rounded-4 p-4 mb-2" style={{ backgroundColor: "#fff3cd", color: "#856404", border: "1px solid #ffeeba", lineHeight: "1.6" }}>
        <h4 className="mb-2 fw-bold">
          <span className="icon me-2">{"\uf0e2"}</span> คืนเงิน / คืนสินค้า {/* \uf0e2 คือ fa-undo */}
        </h4>
        <div>คำสั่งซื้อนี้ถูกดำเนินการคืนเงินหรือคืนสินค้าเรียบร้อยแล้ว</div>
        <small className="opacity-75">ยอดเงินจะถูกคืนเข้าสู่ช่องทางชำระเงินของคุณตามระยะเวลาที่กำหนด</small>
      </div>
    );
  }

  // --- คำนวณสถานะปัจจุบัน (0 ถึง 3) ---
  let currentStep = 0; // ค่าเริ่มต้น: มีคำสั่งซื้อใหม่ (Pending)

  // แก้ไขบั๊กเดิม: ลบคำว่า return ออก เพื่อไม่ให้ฟังก์ชันหยุดทำงานก่อนที่จะ Render UI ด้านล่าง
  if (status === "pending") {
    currentStep = status_payment === "success" ? 1 : 0;
  } else if (status === "preparing") {
    currentStep = 1;
  } else if (status === "delivering") {
    currentStep = 2;
  } else if (status === "success") {
    currentStep = 3;
  }

  // --- กำหนดข้อมูลของแต่ละสเต็ป ---
  const steps = [
    { 
      label: "มีคำสั่งซื้อใหม่", 
      date: detail.created_at ? format_date(detail.created_at, "dd/mm/yyyy hh:mm") : "-", 
      icon: "\uf022" // fa-list-alt
    },
    { 
      label: "ชำระเงินแล้ว/รอจัดส่ง", 
      date: detail.transaction?.payment_date || "-",
      icon: "\uf0d6" // fa-money
    },
    { 
      label: "กำลังจัดส่ง", 
      date: detail.shipped_date || "", 
      icon: "\uf0d1" // fa-truck
    },
    { 
      label: "ทำการจัดส่งแล้ว", 
      date: detail.delivered_date || detail.shipped_date || "", 
      icon: "\uf058" // เปลี่ยนจากรถบรรทุกซ้ำ เป็น fa-check-circle เพื่อให้ดูสำเร็จ
    }
  ];

  return (
    <div className="bg-white rounded-4 p-3 mb-2 border">
      <div className="d-flex justify-content-between align-items-start w-100 mt-2 mb-2 overflow-hidden">
        
        {steps.map((step, index) => {
          const isCompleted = index <= currentStep;
          
          // สเต็ปสุดท้าย (ให้คะแนน) ถ้าทำสำเร็จแล้ว จะทำพื้นหลังทึบ
          const isLastActive = index === steps.length - 1 && isCompleted; 
          
          // การตั้งค่าสี
          const circleBg = isLastActive ? '#22c55e' : '#ffffff';
          const iconColor = isLastActive ? '#ffffff' : (isCompleted ? '#22c55e' : '#d1d5db');
          const borderColor = isCompleted ? '#22c55e' : '#e5e7eb';
          const lineColor = isCompleted ? '#22c55e' : '#e5e7eb';

          return (
            <div key={index} className="d-flex flex-column align-items-center position-relative flex-fill">
              
              {/* เส้นเชื่อม */}
              {index !== 0 && (
                <div 
                  className="position-absolute" 
                  style={{
                    top: '28px', // ครึ่งหนึ่งของความสูงวงกลม (56px)
                    right: '50%',
                    width: '100%',
                    height: '4px',
                    // ปรับให้เส้นเป็นสีเขียวเฉพาะตอนที่ข้ามสเต็ปนั้นไปแล้ว
                    backgroundColor: index <= currentStep ? '#22c55e' : '#e5e7eb', 
                    zIndex: 0,
                    transition: 'background-color 0.3s ease'
                  }}
                ></div>
              )}

              {/* วงกลม Icon */}
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center mb-3 position-relative"
                style={{
                  width: '56px', height: '56px',
                  border: `4px solid ${borderColor}`,
                  backgroundColor: circleBg,
                  color: iconColor,
                  fontSize: '24px',
                  zIndex: 1, // ให้อยู่เหนือเส้นเชื่อม
                  transition: 'all 0.3s ease'
                }}
              >
                <span className="icon">{step.icon}</span>
              </div>

              {/* ข้อความ (Label) */}
              <div 
                className="text-12 fw-bold text-center px-2" 
                style={{ 
                  color: isCompleted ? '#374151' : '#9ca3af', 
                  lineHeight: '1.4'
                }}
              >
                {step.label}
              </div>
              
              {/* วันที่ (Date) */}
              <div className="text-10 mt-1 text-center" style={{ color: '#9ca3af', minHeight: '15px' }}>
                {step.date || '\u00A0'} 
              </div>

            </div>
          )
        })}

      </div>
    </div>
  );
};

  // Skeleton สำหรับการเลื่อนโหลด
  renderSkeleton = () => {
    return Array.from({ length: 3 }).map((_, index) => (
      <div key={`skeleton-${index}`} className="card rounded-4 mb-3 p-3">
        <div className="d-flex flex-wrap justify-content-between placeholder-glow">
          <div className="d-flex mb-3">
            <div className="wpx-100 hpx-100 bg-secondary rounded-4 placeholder" style={{ opacity: 0.2 }}></div>
            <div className="ps-3 d-flex flex-column justify-content-center">
              <div className="placeholder bg-secondary rounded-3 mb-2" style={{ width: "100px", height: "18px", opacity: 0.2 }}></div>
              <div className="placeholder bg-secondary rounded-3 mb-2" style={{ width: "180px", height: "18px", opacity: 0.2 }}></div>
              <div className="placeholder bg-secondary rounded-3" style={{ width: "80px", height: "18px", opacity: 0.2 }}></div>
            </div>
          </div>
          <div className="d-flex align-items-start">
            <div className="placeholder bg-secondary rounded-5" style={{ width: "90px", height: "30px", opacity: 0.2 }}></div>
          </div>
        </div>
        <hr />
        <div className="placeholder-glow mb-2">
          <div className="placeholder bg-secondary rounded-3" style={{ width: "100px", height: "18px", opacity: 0.2 }}></div>
        </div>
        <div className="d-flex justify-content-between border-bottom pt-3 pb-2 placeholder-glow">
          <div className="d-flex w-100">
            <div className="wpx-40 hpx-40 bg-secondary rounded-4 placeholder" style={{ opacity: 0.2 }}></div>
            <div className="px-3 w-100">
              <div className="placeholder bg-secondary rounded-3 mb-2" style={{ width: "60%", height: "14px", opacity: 0.2 }}></div>
              <div className="placeholder bg-secondary rounded-3" style={{ width: "30%", height: "14px", opacity: 0.2 }}></div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  BuyAgain = (items) => {

  }
  render() {
    const { modal_detail, data, filter_data_search, filter_start_date, filter_end_date, filter_status, detail, isLoading } = this.state;

    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="row d-flex justify-content-center mx-0">
          <div className="col-12 col-sm-11 col-md-10 col-lg-2 col-xl-2 pt-5 mt-3 d-none d-lg-block">
            {/* ชื่อผู้ใช้ */}
            <div className="d-flex align-items-center text-start">
              <span className="bg-orange text-dark me-1 wpx-50 hpx-50 text-24 rounded-circle d-flex align-items-center justify-content-center">
                ลค
              </span>
              <div className="px-2 ">
                <div className="text-14 fw-bold">{profile?.full_name || "ลูกค้าทั่วไป"}</div>
                <div className="text-12 text-dark" style={{ marginTop: -2 }}>
                  {profile?.phone || "-"}
                </div>
              </div>
            </div>
            {/* เมนู */}
            <div className="py-3">
              <a href="/profile" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf007"}</span>บัญชีของฉัน</div>
              </a>
              <a href="/address" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf015"}</span>ที่อยู่ของฉัน</div>
              </a>
              <a href="/change-password" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf084"}</span>เปลี่ยนรหัสผ่าน</div>
              </a>
              <a href="/transaction" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf570"}</span>การซื้อของฉัน</div>
              </a>
                <a href="https://page.line.biz/account/@488dmsci" target="_blank" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf4b6"}</span>ติดต่อเรา</div>
              </a>
            </div>
          </div>
          <div className="col-12 col-sm-11 col-md-10 col-lg-9 col-xl-7 col-xxl-6 my-4 px-3 min-vh-100">
            <h4 className="fw-bold mb-3">รายการสั่งซื้อของฉัน</h4>
            <div className="rounded-4 bg-white p-3 mb-3">
              <div className="d-flex overflow-scroll mb-3 bg-light justify-content-start">
                {[
                  { icon: "\uf468", label: "ทั้งหมด", value: "", count: 0 },
                  { icon: "\uf555", label: "ที่ต้องชำระเงิน", value: "pending", count:  this.state.count_pending },
                  { icon: "\uf466", label: "ที่ต้องจัดส่ง", value: "preparing", count:  this.state.count_preparing },
                  { icon: "\uf48b", label: "ระหว่างขนส่ง", value: "delivering", count:  this.state.count_delivering },
                  { icon: "\uf336", label: "จัดส่งแล้ว", value: "success", count:  this.state.count_success },
                  { icon: "\uf0e2", label: "การคืนสินค้า", value: "returned", count:  this.state.count_returned },
                  { icon: "\uf290", label: "การยกเลิก", value: "cancel", count:  this.state.count_cancel },
                ].map(e=>(
                <button className={`btn btn-light text-nowrap pb-1 px-4 rounded-0 position-relative ${filter_status === e.value ? "btn-active" : "btn-bt"}`} onClick={() => this.setState({ filter_status: e.value, filter_search: "" },() => {this.Get(1)})}>
                  <div className="d-none d-md-block icon me-2 text-30">{e.icon}</div>
                  <div className="hpx-30">{e.label}</div>
                  {e.count !== 0 && (
                  <span className="wpx-25 hpx-25 text-12 fw-bold rounded-circle bg-danger text-light d-flex align-items-center justify-content-center position-absolute" style={{right:20, top:8}}>{e.count < 99 ? e.count : "99+"}</span>
                  )}
                </button>
                ))}
              </div>
              <div className="d-flex d-md-none">
                <div className="w-100 pe-2">
                <input
                    type="text" className="form-control w-100 mb-2" placeholder="เลขออร์เดอร์..."
                    onChange={(e) => this.setState({ filter_data_search: e.target.value })}
                    value={filter_data_search}
                  />
                  <div className="w-100 me-2 mb-2">
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => this.setState({ filter_start_date: e.start_date, filter_end_date: e.end_date })}
                    value={{ start_date: filter_start_date, end_date: filter_end_date }}
                    max={filter_end_date}
                  />
                </div>
                </div>
                <div>
                  <button className="btn bg-orange px-3 me-2 mb-2" onClick={() => this.setState({ data: [] }, () => this.Get(1))}>ค้นหา</button>
                </div>
              </div>
              <div className="d-none d-md-flex justify-content-center">
                <input
                  type="text" className="form-control w-100 me-2 mb-2" placeholder="เลขออร์เดอร์..."
                  onChange={(e) => this.setState({ filter_data_search: e.target.value })}
                  value={filter_data_search}
                />
                <div className="wpx-230 me-2 mb-2">
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => this.setState({ filter_start_date: e.start_date, filter_end_date: e.end_date })}
                    value={{ start_date: filter_start_date, end_date: filter_end_date }}
                    max={filter_end_date}
                  />
                </div>
                <div className="d-flex">
                  {/* เมื่อค้นหาใหม่ให้เคลียร์ data และโหลดหน้า 1 */}
                  <button className="btn bg-orange px-3 me-2 mb-2 text-nowrap" onClick={() => this.setState({ data: [] }, () => this.Get(1))}>ค้นหา</button>
                  <button className="btn btn-outline-dark px-3 me-2 mb-2 text-nowrap" onClick={() => window.location.reload()}>ล้างค่า</button>
                </div>
              </div>
            </div>

            {/* รายการออร์เดอร์ */}
            {data?.map((item, index) => (
              <div key={index} className="card rounded-4 mb-3 p-3">
                <div className="d-flex flex-wrap justify-content-between">
                    <div>
                      <small className="bg-orange px-2 rounded-3 text-white">{format_date(item.created_at, "dd/mm/yyyy hh:mm")}</small>
                      <div className="fw-bold">#{item.order_no || ""}-{item.transaction?.reference_id || ""}</div>
                    </div>
                  <div className="d-flex align-items-start">
                    {this.renderStatusBadge(item)}
                    {Number(item.total_price) > 10000 && Status("pre order", "info")}
                  </div>
                </div>
                
                <hr className="my-1" />
                {/* <div className="fw-bold mb-2">รายการสินค้า</div> */}
                {item.order_items?.map(this.renderOrderItem)}
                <div className="d-flex align-items-center justify-content-end mt-3">
                  <span>รวมการสั่งซื้อ:</span><h3 className="fw-bold mb-0 ms-3">฿{toFixed(item.transaction?.amount)}</h3>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <button className="btn btn-sm btn-link px-2 text-decoration-none" onClick={() => this.setState({ modal_detail: true, detail: item })}>
                    รายละเอียด
                  </button>
                  <div className="d-flex">
                    {Number(item.total_price) > 10000 && (
                      <button className="btn btn-dark px-3 ms-2" onClick={() => report_preorder(item)}>
                        <span className="icon me-2">{"\uf1c1"}</span>PreOrder
                      </button>
                    )}
                    <button className="btn btn-dark px-3 ms-2" onClick={() => report_tax_invoice(item)}>
                      <span className="icon me-2">{"\uf1c1"}</span>ใบเสร็จรับเงิน
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {/* แสดง Skeleton เมื่อกำลังโหลดข้อมูล */}
            {isLoading && this.renderSkeleton()}

          </div>
        </div>
        

        {/* Modal รายละเอียด */}
        <Modal show={modal_detail} onHide={() => this.setState({ modal_detail: false })} size="lg">
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายละเอียดการสั่งซื้อ</h5>
          </Modal.Header>
          <Modal.Body className="bg-light">
            {/* สถานะการสั่งซื้อ */}
            {this.renderModalBanner(detail)}

            {/* ที่อยู่สำหรับการจัดส่ง */}
            <div className="rounded-4 bg-white p-3 mb-2 border">
              <h6 className="fw-bold">ที่อยู่ในการจัดส่ง</h6>
              <div className="d-flex">
                <span className="icon me-2">{"\uf3c5"}</span>
                <div>
                  <span>{detail?.customer?.name_en || " "} <span className="text-secondary">{detail?.customer?.phone || ""}</span></span><br />
                  <span>{`${detail?.address || ""} ${detail?.sub_district ? "ต." + detail?.sub_district : ""} ${detail?.district ? "อ." + detail?.district : ""} ${detail?.province ? "จ." + detail?.province : ""} ${detail?.zipcode || ""}`}</span>
                </div>
              </div>
            </div>
            
            {/* รายการสินค้า */}
            <div className="rounded-4 bg-white p-3 mb-2 border">
              <h6 className="fw-bold mb-2">รายการสินค้า</h6>
              {detail?.order_items?.map(this.renderOrderItem)}
            </div>

            {/* รายละเอียดการสั่งซื้อ */}
            <div className="rounded-4 bg-white p-3 mb-2 border">
              <div className="d-flex justify-content-between mb-3"><span className="me-3">หมายเลขคำสั่งซื้อ</span><span>#{detail?.order_no || ""}-{detail?.transaction?.reference_id || ""}</span></div>
              <div className="d-flex justify-content-between mb-3"><span className="me-3">ชำระผ่าน</span><span>QRCode - พร้อมเพย์ Promptpay</span></div>
              <div className="d-flex justify-content-between mb-3"><span className="me-3">วันเวลาที่สั่งซื้อ</span><span>{format_date(detail?.created_at, "dd/mm/yyyy hh:mm") || ""}</span></div>
              <div className="d-flex justify-content-between"><span className="me-3">หมายเหตุ</span><span>{detail?.remark || detail?.delivery_remark || "-"}</span></div>
            </div>

            {/* บริการหลังการขาย */}
            <div className="rounded-4 bg-white p-3 mb-2 border">
              <h6 className="fw-bold mb-3">บริการหลังการขาย</h6>
              {detail?.order_status === "success" && (
              <div className="d-flex justify-content-between mb-3 pb-2 border-bottom text-decoration-none text-dark pointer" onClick={async() => {
                
                Swal.fire({
                    icon: "info",
                    title: "ขอคืนเงิน/คืนสินค้า",
                    html:`
                      <div class="text-start">
                        <p>ทางเรามุ่งมั่นที่จะมอบบริการที่ดีที่สุดให้แก่คุณ อย่างไรก็ตาม หากคุณพบปัญหาเกี่ยวกับสินค้าหรือต้องการขอคืนเงิน ระบบมีขั้นตอนและเงื่อนไขดังนี้:</p>
                        
                        <h6 class="fw-bold mt-3">ขั้นตอนการดำเนินการ:</h6>
                        <p class="text-muted">
                          เนื่องจากการตรวจสอบสินค้าและการอนุมัติยอดเงินคืนจำเป็นต้องใช้การพิจารณาเป็นรายกรณี <b>ระบบจึงไม่สามารถกดยกเลิกและคืนเงินอัตโนมัติได้ทันที</b> 
                          ลูกค้าจำเป็นต้องติดต่อเจ้าหน้าที่ฝ่ายบริการลูกค้า (Admin) เพื่อแจ้งเรื่องเท่านั้น
                        </p>

                        <ul class="text-muted">
                          <li><b>แจ้งเรื่อง:</b> ติดต่อ Admin ผ่านช่องทาง LINE Official เพื่อระบุหมายเลขคำสั่งซื้อ</li>
                          <li><b>หลักฐาน:</b> กรุณาแนบรูปภาพหรือวิดีโอขณะเปิดกล่องพัสดุ (Unboxing) และภาพสินค้าที่มีปัญหา</li>
                          <li><b>การตรวจสอบ:</b> เจ้าหน้าที่จะใช้เวลาตรวจสอบภายใน 1-3 วันทำการ และแจ้งผลให้ทราบทางแชท</li>
                        </ul>

                        <div class="alert alert-info d-flex align-items-center mt-3">
                          <div>
                            <b>💬 ติดต่อเจ้าหน้าที่เพื่อดำเนินการ:</b><br />
                            กรุณาคลิกที่ลิงก์นี้เพื่อเข้าสู่ LINE Official: 
                            <a href="https://page.line.biz/account/@488dmsci" target="_blank" class="alert-link ms-1">
                              @488dmsci
                            </a>
                          </div>
                        </div>

                        <hr />
                        <h6 class="fw-bold">เงื่อนไขการรับเปลี่ยน/คืน:</h6>
                        <ol class="small text-muted">
                          <li>สินค้าต้องอยู่ในสภาพเดิม พร้อมบรรจุภัณฑ์และป้ายสินค้า (ถ้ามี)</li>
                          <li>ต้องแจ้งเรื่องภายใน 7 วัน นับจากวันที่ได้รับพัสดุตามระบบขนส่ง</li>
                          <li>กรณีคืนเงินเนื่องจากเปลี่ยนใจ (โดยที่สินค้าไม่ได้เสียหาย) อาจมีค่าธรรมเนียมการดำเนินการตามที่บริษัทกำหนด</li>
                        </ol>
                      </div>
                    `,
                    confirmButtonText: "ติดต่อเรา",
                    showCancelButton: true,
                    cancelButtonText: "ยกเลิก",
                    background: "#fff", // Dark / Light background
                    color: "#000000", // Text color
                    confirmButtonColor: "#212529",
                    cancelButtonColor: "unset",
                  }).then(({ isConfirmed }) => {
                    if (isConfirmed) {
                       window.open("https://page.line.biz/account/@488dmsci","_blank");
                    }
                    return isConfirmed;
                  });
              }}>
                <div className="d-flex"><span className="icon me-2">{"\uf0e2"}</span>ขอคืนเงิน/คืนสินค้า</div>
                <span className="icon text-secondary">{"\uf054"}</span>
              </div>
              )}
              <a href="https://page.line.biz/account/@488dmsci" target="_blank" className="d-flex justify-content-between mb-3 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf4b6"}</span>ติดต่อเรา</div>
                <span className="icon text-secondary">{"\uf054"}</span>
              </a>
              <a href="/help" target="_blank" className="d-flex justify-content-between pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon me-2">{"\uf059"}</span>ศูนย์ช่วยเหลือ</div>
                <span className="icon text-secondary">{"\uf054"}</span>
              </a>
            </div>
            <div className="d-flex justify-content-between">
              {(["pending","preparing"].includes(detail?.order_status) || detail?.transaction?.status === "pending") && detail?.transaction?.status !== "cancel" ? (
                <button className="btn btn-link text-decoration-none text-danger d-flex" onClick={() => {this.CancelTransaction(detail?.uid)}}>ยกเลิกรายการ</button>
              ): (<div></div>)}
              {/* {(["cancel","success","returned"].includes(detail?.order_status) || detail?.transaction?.status === "cancel") && (
                <button className="btn btn-link text-decoration-none d-flex" onClick={() => {this.BuyAgain(detail?.order_items)}}>สั่งซื้ออีกครั้ง</button>
              )} */}
              </div>

          </Modal.Body>
        </Modal>
        <Footer />
      </div>
    );
  }
}